
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/web3-fund-management",
      function () {
        return require("private-next-pages/solutions/web3-fund-management.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/web3-fund-management"])
      });
    }
  